import getStore from '../store/store';
import { ObservableMap } from 'mobx';
import MailBoxData from '../store/schema/MailboxData';

/**
 * Selector for mailbox table
 */
export default function getMailboxTable(): ObservableMap<string, MailBoxData> {
    return getStore().mailboxTable;
}
